import React from 'react';
import styled from 'styled-components';

import ButtonDefault, {
  ButtonPrimary,
} from '../../../components/forms/Buttons';

const ButtonWrapper = styled.div`
  margin-left: 10px;
`;
const ButtonRowWrapper = styled.div`
  display: flex;
  flex-direction: row-reverse;
  padding-top: 15px;
`;

interface FormButtonRowProps {
  onClear: () => void;
  onSubmit: () => void;
  saveDisabled?: boolean;
  clearText?: string;
  submitText?: string;
  loggedInAndEditUserSame?: boolean;
}

export const FormButtonRow: React.FC<FormButtonRowProps> = ({
  onClear,
  onSubmit,
  saveDisabled = false,
  clearText = 'CLEAR',
  submitText = 'SEARCH',
  loggedInAndEditUserSame = false,
}) => (
  <ButtonRowWrapper>
    <ButtonWrapper>
      <ButtonPrimary
        id="searchButton"
        onClick={onSubmit}
        disabled={saveDisabled || loggedInAndEditUserSame}
      >
        {submitText.toUpperCase()}
      </ButtonPrimary>
    </ButtonWrapper>
    <ButtonWrapper>
      <ButtonDefault id="clearButton" onClick={onClear} disabled={loggedInAndEditUserSame}>
        {clearText.toUpperCase()}
      </ButtonDefault>
    </ButtonWrapper>
  </ButtonRowWrapper>
);
